// extracted by mini-css-extract-plugin
export var contacts = "ContactsModule-module--contacts--1Dunf";